import React from 'react';

const imageModalStyles = `
  .image-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: zoom-out;
    animation: imageModalFadeIn 0.3s ease;
  }

  @keyframes imageModalFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .image-modal-content {
    max-width: 95vw;
    max-height: 95vh;
    object-fit: contain;
    animation: imageModalZoomIn 0.3s ease;
    cursor: default;
  }

  @keyframes imageModalZoomIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .image-modal-close {
    position: absolute;
    top: 20px;
    right: 30px;
    color: white;
    font-size: 40px;
    font-weight: bold;
    cursor: pointer;
    z-index: 10000;
    transition: transform 0.2s ease;
  }

  .image-modal-close:hover {
    transform: scale(1.2);
  }

  .image-clickable {
    cursor: zoom-in;
    transition: transform 0.2s ease;
  }

  .image-clickable:hover {
    transform: scale(1.02);
  }
`;

const ImageModal = ({ isOpen, onClose, imageSrc }) => {
  if (!isOpen) return null;

  return (
    <>
      <style>{imageModalStyles}</style>
      <div className="image-modal-overlay" onClick={onClose}>
        <span className="image-modal-close" onClick={onClose}>&times;</span>
        <img
          src={imageSrc}
          alt="Full size preview"
          className="image-modal-content"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </>
  );
};

export default ImageModal;
